import React, { useContext, useEffect } from 'react';
import { ReviewsContext } from './ReviewsContext';

// Remove SortOptionContext if it's not used elsewhere and causing issues
// export const SortOptionContext = createContext(); 

const SortOptionProvider = ({ children }) => {
  const { 
    sortOption, // Keep sortOption if needed by the effect
    setSelectedSubjectGroup, // Use correct name
    setSelectedAttribute, 
    setSelectedCategory 
  } = useContext(ReviewsContext);

  // Reset filters when sort option changes
  useEffect(() => {
    if (setSelectedSubjectGroup) { // Use correct name
        setSelectedSubjectGroup(null);
    }
    if (setSelectedAttribute) {
        setSelectedAttribute(null);
    }
    // Don't reset category when sort option changes (based on original logic inference)
    // if (setSelectedCategory) {
    //   setSelectedCategory(null);
    // }
  }, [sortOption, setSelectedSubjectGroup, setSelectedAttribute, setSelectedCategory]); // Restore dependencies potentially?

  // Revert to just returning children as before
  return children;
};

export default SortOptionProvider; // Revert to default export to match original pattern? 